// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1Ucsj","noInteraction":"EventWrapper_noInteraction__2n0_o","pointerPassthrough":"EventWrapper_pointerPassthrough__3f1bQ"};